import { render, staticRenderFns } from "./GoToFlixcheckCreateCheckButton.vue?vue&type=template&id=3a482a34&scoped=true"
import script from "./GoToFlixcheckCreateCheckButton.vue?vue&type=script&lang=ts"
export * from "./GoToFlixcheckCreateCheckButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a482a34",
  null
  
)

export default component.exports